import { defineElement } from '~/utils';

class LoadingBar extends HTMLElement {
  constructor() {
    super();
    this._onLoadingStart = this._onLoadingStart.bind(this);
    this._onLoadingEnd = this._onLoadingEnd.bind(this);

    document.addEventListener('theme:loading:start', this._onLoadingStart);
    document.addEventListener('theme:loading:end', this._onLoadingEnd);
  }

  _onLoadingStart() {
    this.animate(
      [
        { opacity: 0, transform: 'scaleX(0)' },
        { opacity: 1, transform: 'scaleX(0.4)' },
      ],
      { duration: 250, fill: 'forwards' }
    );
  }

  async _onLoadingEnd() {
    await this.animate([{ transform: 'scaleX(1)' }], { duration: 250, fill: 'forwards' }).finished;

    this.animate([{ opacity: 0 }], { duration: 250, fill: 'forwards' });
  }

  disconnectedCallback() {
    document.removeEventListener('theme:loading:start', this._onLoadingStart);
    document.removeEventListener('theme:loading:end', this._onLoadingEnd);
  }
}

defineElement('loading-bar', LoadingBar);
